import { Outlet, Navigate } from "react-router-dom";
import { useFlags, useFlagsLoaded } from "@/hooks/useFeatureFlags";
import { isAchievementsReportEnabled } from "@/pages/people/_membershipServicesNavLinks";

export default function AchievementsReportLayout() {
  const flags = useFlags();
  const flagsLoaded = useFlagsLoaded();

  if (!flagsLoaded) {
    return null;
  }

  if (!isAchievementsReportEnabled(flags)) {
    return <Navigate to="/people/membership-services" replace />;
  }

  return <Outlet />;
}
